// extracted by mini-css-extract-plugin
export default {"native-app-error":"native-app-error--dJDFt","nativeAppError":"native-app-error--dJDFt","content":"content--DF8cF"};